var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasViewPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasViewPermission,
              expression: "hasViewPermission"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c("div", { staticClass: "main-dialog" }, [
            _c(
              "div",
              { attrs: { id: "card-container" } },
              [
                _c("div", { staticClass: "input-form" }, [
                  _c("div", { staticClass: "card-design" }, [
                    _c("div", [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("system.user.query")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "all-forms" }, [
                        !_vm.$store.getters.isMerchant
                          ? _c(
                              "div",
                              { staticClass: "form" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("SMS.organizationName")) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "filter-item",
                                    attrs: {
                                      placeholder: _vm.$t("SMS.pleaseChoose"),
                                      clearable: "",
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.listQuery.organizationCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "organizationCode",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.organizationCode"
                                    }
                                  },
                                  _vm._l(_vm.organizationNameOption, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.organizationCode,
                                      attrs: {
                                        label: item.organizationName,
                                        value: item.organizationCode
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.fullName")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.listQuery.userName,
                                callback: function($$v) {
                                  _vm.$set(_vm.listQuery, "userName", $$v)
                                },
                                expression: "listQuery.userName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.loginAccount")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "filter-item",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("SMS.pleaseEnterText")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleFilter($event)
                                }
                              },
                              model: {
                                value: _vm.listQuery.userAccount,
                                callback: function($$v) {
                                  _vm.$set(_vm.listQuery, "userAccount", $$v)
                                },
                                expression: "listQuery.userAccount"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.status")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.listQuery.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "status", $$v)
                                  },
                                  expression: "listQuery.status"
                                }
                              },
                              _vm._l(_vm.statusOption, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("SMS.forceBindGoogleText")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  placeholder: _vm.$t("SMS.pleaseChoose"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.listQuery.isGoogle,
                                  callback: function($$v) {
                                    _vm.$set(_vm.listQuery, "isGoogle", $$v)
                                  },
                                  expression: "listQuery.isGoogle"
                                }
                              },
                              _vm._l(this.forceBindGoogleOption, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.display_name,
                                    value: item.key
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "primary",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "otherActions" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("unlock"),
                              expression: "hasPermissionEx('unlock')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleBatchUnlock("batchUnlock")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.batchUnlock")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("lock"),
                              expression: "hasPermissionEx('lock')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-error"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleBatchLock("batchLock")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.batchLock")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("resetPassword"),
                              expression: "hasPermissionEx('resetPassword')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-refresh"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleResetPassword("resetPassword")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.resetPassword")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("limitUpdate"),
                              expression: "hasPermissionEx('limitUpdate')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "info",
                            icon: "el-icon-edit"
                          },
                          on: { click: _vm.handleBatchUpdatePermission }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("common.batchUpdatePermissionText")
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "addEditOrDelete" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasAddPermission,
                              expression: "hasAddPermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-plus"
                          },
                          on: { click: _vm.handleCreate }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.add")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            { name: "waves", rawName: "v-waves" },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasDeletePermission,
                              expression: "hasDeletePermission"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleDelete("delete")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("common.delete")) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasViewPermission,
                        expression: "hasViewPermission"
                      },
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading"
                      }
                    ],
                    key: _vm.tableKey,
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      stripe: _vm.$store.getters.stripeConf,
                      border: _vm.$store.getters.borderConf,
                      "highlight-current-row": "",
                      fit: ""
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        label: "",
                        align: "center",
                        width: "45",
                        fixed: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.organizationName"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertOrganizationName(
                                      scope.row.organizationCode
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.convertOrganizationName(
                                              scope.row.organizationCode
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.fullName"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.userName
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.userName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.loginAccount"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.userAccount
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.userAccount))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.accountType"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertAccountTypeName(
                                      scope.row.accountType
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertAccountTypeName(
                                            scope.row.accountType
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.status"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("sm")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertStatusOptionName(
                                      scope.row.status
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertStatusOptionName(
                                            scope.row.status
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.forceBindGoogleText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("lg")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertForceGoogleOptionName(
                                      scope.row.isGoogle
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertForceGoogleOptionName(
                                            scope.row.isGoogle
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.isStoredGoogleText"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("lg")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.convertGoogleStatusOptionName(
                                      scope.row.isStoredGoogle
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertGoogleStatusOptionName(
                                            scope.row.isStoredGoogle
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isAgent || _vm.$store.getters.isMerchant
                      ? _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("SMS.loginFailedCount"),
                            align: "center",
                            "min-width": _vm.customTableColumnWidth("md")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          content: scope.row.loginFaildCount.toString()
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "ellipsis",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.loginFaildCount)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2968787743
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.lastLoginIPAddress"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.lastLoginIp
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.lastLoginIp))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.lastLoginTime"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: scope.row.lastLoginTime
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(scope.row.lastLoginTime))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("common.createTime"),
                        align: "center",
                        "min-width": _vm.customTableColumnWidth("md")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    trigger: "click",
                                    content: _vm.dateFormat(
                                      scope.row.createDate
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(scope.row.createDate)
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SMS.operating"),
                        width: "300",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasUpdatePermission,
                                      expression: "hasUpdatePermission"
                                    }
                                  ],
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "primary",
                                    icon: "el-icon-edit",
                                    size: "mini",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdate(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.edit")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("limitUpdate"),
                                      expression:
                                        "hasPermissionEx('limitUpdate')"
                                    }
                                  ],
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-edit-outline",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleUpdatePermission(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("common.permission")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("google:key"),
                                      expression:
                                        "hasPermissionEx('google:key')"
                                    }
                                  ],
                                  attrs: {
                                    round: _vm.$store.getters.roundConf,
                                    type: "info",
                                    size: "mini",
                                    plain: _vm.$store.getters.plainConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleQrcode(row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SMS.googleQrCode")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx("forceLogoff"),
                                      expression:
                                        "hasPermissionEx('forceLogoff')"
                                    }
                                  ],
                                  staticStyle: { "margin-top": "5px" },
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-error",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleForceLogoff(
                                        row.id,
                                        row.userName
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("SMS.forceLogoffText")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasPermissionEx(
                                        "removeGoogle"
                                      ),
                                      expression:
                                        "hasPermissionEx('removeGoogle')"
                                    }
                                  ],
                                  staticStyle: { "margin-top": "5px" },
                                  attrs: {
                                    plain: _vm.$store.getters.plainConf,
                                    type: "warning",
                                    size: "mini",
                                    icon: "el-icon-error",
                                    round: _vm.$store.getters.roundConf
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemoveGoogle(
                                        row.id,
                                        row.userName
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("SMS.removeGoogle")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasViewPermission,
                      expression: "hasViewPermission"
                    }
                  ],
                  attrs: {
                    total: _vm.total,
                    page: _vm.listQuery.pageNum,
                    limit: _vm.listQuery.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.listQuery, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.listQuery, "pageSize", $event)
                    },
                    pagination: _vm.getList
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog" },
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          id: "dialog",
                          visible: _vm.dialogFormVisible,
                          width: "700px"
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogFormVisible = $event
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card" },
                          [
                            _c("div", { staticClass: "card-title" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.textMap[_vm.dialogType]) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "close" }, [
                                _c("i", {
                                  staticClass: "el-icon-close",
                                  on: {
                                    click: function($event) {
                                      _vm.dialogFormVisible = false
                                    }
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.formLoading,
                                    expression: "formLoading"
                                  }
                                ],
                                ref: "dataForm",
                                attrs: {
                                  rules: _vm.rules,
                                  model: _vm.formTemp,
                                  "label-position": "left",
                                  "label-width": "220px"
                                }
                              },
                              [
                                _vm.$store.getters.isAdmin ||
                                _vm.dialogType === "create" ||
                                _vm.$store.getters.isMerchant
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SMS.organizationName"),
                                          prop: "organizationCode"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "filter-item",
                                            attrs: {
                                              disabled:
                                                _vm.$store.getters.isMerchant ||
                                                _vm.dialogType === "update",
                                              placeholder: _vm.$t(
                                                "option.pleaseChoose"
                                              ),
                                              clearable: "",
                                              filterable: ""
                                            },
                                            model: {
                                              value:
                                                _vm.formTemp.organizationCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTemp,
                                                  "organizationCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTemp.organizationCode"
                                            }
                                          },
                                          _vm._l(
                                            _vm.organizationNameOption,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.organizationCode,
                                                attrs: {
                                                  label: item.organizationName,
                                                  value: item.organizationCode
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.fullName"),
                                      prop: "userName"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.formTemp.userName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formTemp,
                                            "userName",
                                            $$v
                                          )
                                        },
                                        expression: "formTemp.userName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.loginAccount"),
                                      prop: "userAccount"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: _vm.dialogType !== "create"
                                      },
                                      model: {
                                        value: _vm.formTemp.userAccount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formTemp,
                                            "userAccount",
                                            $$v
                                          )
                                        },
                                        expression: "formTemp.userAccount"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.dialogType === "create"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SMS.password"),
                                          prop: "userPassword"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "password",
                                            "show-password": ""
                                          },
                                          model: {
                                            value: _vm.formTemp.userPassword,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formTemp,
                                                "userPassword",
                                                $$v
                                              )
                                            },
                                            expression: "formTemp.userPassword"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dialogType === "create"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SMS.confirmPassword"),
                                          prop: "checkPassword"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "password",
                                            "show-password": ""
                                          },
                                          model: {
                                            value: _vm.formTemp.checkPassword,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formTemp,
                                                "checkPassword",
                                                $$v
                                              )
                                            },
                                            expression: "formTemp.checkPassword"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.dialogType === "create"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SMS.payPassword"),
                                          prop: "payPassword"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "password",
                                            "show-password": ""
                                          },
                                          model: {
                                            value: _vm.formTemp.payPassword,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formTemp,
                                                "payPassword",
                                                $$v
                                              )
                                            },
                                            expression: "formTemp.payPassword"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$store.getters.isAdmin
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SMS.accountType"),
                                          prop: "accountType"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticClass: "filter-item",
                                            attrs: {
                                              disabled:
                                                _vm.dialogType === "update",
                                              filterable: "",
                                              clearable: "",
                                              placeholder: _vm.$t(
                                                "option.pleaseChoose"
                                              )
                                            },
                                            model: {
                                              value: _vm.formTemp.accountType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTemp,
                                                  "accountType",
                                                  $$v
                                                )
                                              },
                                              expression: "formTemp.accountType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.accountTypeOption,
                                            function(option) {
                                              return _c("el-option", {
                                                key: option.key,
                                                attrs: {
                                                  label: option.display_name,
                                                  value: option.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.status"),
                                      prop: "status"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          filterable: "",
                                          clearable: "",
                                          placeholder: _vm.$t(
                                            "option.pleaseChoose"
                                          )
                                        },
                                        model: {
                                          value: _vm.formTemp.status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formTemp,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "formTemp.status"
                                        }
                                      },
                                      _vm._l(_vm.statusOption, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.key,
                                          attrs: {
                                            label: option.display_name,
                                            value: option.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.forceBindGoogleText")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "filter-item",
                                        attrs: {
                                          filterable: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.formTemp.isGoogle,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formTemp,
                                              "isGoogle",
                                              $$v
                                            )
                                          },
                                          expression: "formTemp.isGoogle"
                                        }
                                      },
                                      _vm._l(
                                        _vm.forceBindGoogleOption,
                                        function(option) {
                                          return _c("el-option", {
                                            key: option.key,
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "option.pleaseChoose"
                                              ),
                                              label: option.display_name,
                                              value: option.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SMS.description"),
                                      prop: "description"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.formTemp.description,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formTemp,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "formTemp.description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "confirm-button" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.dialogFormVisible = false
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.cancel")) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.formLoading,
                                        expression: "formLoading"
                                      }
                                    ],
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.dialogType === "create"
                                          ? _vm.doCreateData()
                                          : _vm.doUpdateData()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.confirm")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: _vm.$t("SMS.updateRolePermissions"),
                      "close-on-click-modal": (_vm.boolTrue = false),
                      visible: _vm.dialogTreeVisible,
                      width: "600px"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogTreeVisible = $event
                      },
                      close: _vm.handleResetTree
                    }
                  },
                  [
                    _c("div", { staticClass: "tree-diagram" }, [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("SMS.rolePermissions")) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "scrollbar" },
                        [
                          _c(
                            "el-scrollbar",
                            { attrs: { "wrap-class": "scrollbar-wrapper" } },
                            [
                              _c("el-tree", {
                                ref: "tree",
                                attrs: {
                                  data: _vm.permissionTree,
                                  "show-checkbox": "",
                                  "node-key": "id",
                                  "highlight-current": "",
                                  props: _vm.defaultProps,
                                  "check-strictly": ""
                                },
                                on: { check: _vm.handleCheck }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { float: "right" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.doPermissionUpdate }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.confirm")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "agent-dialog" },
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: _vm.$t("SMS.bingQrcode"),
                          visible: _vm.dialogQrcodeVisible,
                          width: "330px",
                          center: true
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogQrcodeVisible = $event
                          }
                        }
                      },
                      [
                        _c("el-container", {
                          staticStyle: {
                            width: "400px",
                            "margin-left": "20px"
                          },
                          attrs: { id: "qrcode" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "el-dialog__footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogQrcodeVisible = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.closedText")) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }